import Funnel from '../funnel/funnel.jsx';
import { useEffect } from 'react';

const StringsNumbersJS = () => {
    useEffect(()=>{
        window.sessionStorage.setItem('cartValue', "£"+Math.floor(Math.random() * (10000 - 100) + 100) / 100)

    },[])
  return (
    <div style={{ textAlign: 'left' }}>
      <h1>JavaScript: Strings and Numbers</h1>
      <p>The user's cart value during the checkout steps below is stored in the browser session storage, and not visible in the HTML the user sees.</p>
      <p>Unfortunately, the current cart value is in GBP and needs to be converted to USD. We can assume the conversion rate from GBP to USD is 1.38</p>
      <p>Using the JavaScript editor on the right, retrieve the current cart value from Session Storage and convert the value to it's USD equivalent. Console log the result</p>
      <Funnel defaultStep={1} errorState={false}/>
    </div>
  )

}

export default StringsNumbersJS;